import { Routes } from "@angular/router";
import { canMatchAuthGuard } from "../guards/auth.guard";

export const adminRoutes: Routes = [
    {
        path: 'dashboard',
        loadComponent: () => import('../../features/dashboard/components/dashboard/dashboard.component').then(m => m.DashboardComponent),
    }, 
    {
        path: 'user-list',
        loadComponent: () => import('../../features/users/components/users/users.component').then(m => m.UsersComponent),
        // canMatch: [canMatchAuthGuard],
        // data: { permission: 'User Management.read' }
    }, 
    {
        path: 'user-add',
        loadComponent: () => import('../../features/users/components/user-add/user-add.component').then(m => m.UserAddComponent),
    },
    {
        path: 'user-edit/:id',
        loadComponent: () => import('../../features/users/components/user-add/user-add.component').then(m => m.UserAddComponent),
    },
    {
        path: 'book-list',
        loadComponent: () => import('../../features/bible/components/book-list/book-list.component').then(m => m.BookListComponent),
    },
    {
        path: 'book-master',
        loadComponent: () => import('../../features/bible/components/book-master/book-master.component').then(m => m.BookMasterComponent),
    },
    {
        path: 'verse-details',
        loadComponent: () => import('../../features/bible/components/tag-add/tag-add.component').then(m => m.TagAddComponent),
    },
    {
        path: 'version-list',
        loadComponent: () => import('../../features/bible/components/version-list/version-list.component').then(m => m.VersionListComponent),
    }, 
    {
        path: 'version-master',
        loadComponent: () => import('../../features/bible/components/version-master/version-master.component').then(m => m.VersionMasterComponent),
    }, 
    {
        path: 'language-list',
        loadComponent: () => import('../../features/bible/components/language-list/language-list.component').then(m => m.LanguageListComponent),
    }, 
    {
        path: 'upload-data',
        loadComponent: () => import('../../features/bible/components/upload-data/upload-data.component').then(m => m.UploadDataComponent),
    }, 
    // {
    //     path: 'book-details/:id',
    //     loadComponent: () => import('../../features/bible/components/book-view/book-view.component').then(m => m.BookViewComponent),
    // },
    {
        path: 'churches-list',
        loadComponent: () => import('../../features/churches/components/churches-list/churches-list.component').then(m => m.ChurchesListComponent),
    }, 
    {
        path: 'churches-add',
        loadComponent: () => import('../../features/churches/components/churches-add/churches-add.component').then(m => m.ChurchesAddComponent),
    },
    // {
    //     path: 'church-upload',
    //     loadComponent: () => import('../../features/churches/components/church-upload/church-upload.component').then(m => m.ChurchUploadComponent),
    // },
    {
        path: 'churches/edit/:id',
        loadComponent: () => import('../../features/churches/components/churches-edit/churches-edit.component').then(m => m.ChurchesEditComponent),
    },
    {
        path: 'churches/view/:id',
        loadComponent: () => import('../../features/churches/components/churches-view/churches-view.component').then(m => m.ChurchesViewComponent),
    },
    {
        path: 'roles-list',
        loadComponent: () => import('../../features/role/components/roles/roles.component').then(m => m.RolesComponent),
    },
    {
        path: 'modules-list',
        loadComponent: () => import('../../features/module/components/modules/modules.component').then(m => m.ModulesComponent),
    },
    {
        path: 'profile',
        loadComponent: () => import('../../features/profile/components/view/view.component').then(m => m.ViewComponent),
    },
    {
        path: 'denominations-add',
        loadComponent: () => import('../../features/denominations/components/denominations-add/denominations-add.component').then(m => m.DenominationsAddComponent),
    },
    {
        path: 'denominations-edit/:id',
        loadComponent: () => import('../../features/denominations/components/denominations-add/denominations-add.component').then(m => m.DenominationsAddComponent),
    },
    {
        path: 'denominations-list',
        loadComponent: () => import('../../features/denominations/components/denominations/denominations.component').then(m => m.DenominationsComponent),
    },
    {
        path: 'occasions-list',
        loadComponent: () => import('../../features/occasions/components/occasions/occasions.component').then(m => m.OccasionsComponent),
    },
     {
        path: 'timings',
        loadComponent: () => import('../../features/timing/components/timing/timing.component').then(m => m.TimingComponent),
    },
    {
        path: 'topics',
        loadComponent: () => import('../../features/feeds/components/topics/topics.component').then(m => m.TopicsComponent),
    },
    {
        path: 'groups',
        loadComponent: () => import('../../features/group/components/group-list/group-list.component').then(m => m.GroupListComponent),
    },
    {
        path: 'groups/view/:id',
        loadComponent: () => import('../../features/group/components/group-view/group-view.component').then(m => m.GroupViewComponent),
    },
    {
        path: 'mood-list',
        loadComponent: () => import('../../features/mood/components/moods/moods.component').then(m => m.MoodsComponent),
    },
     {
        path: 'relationship-list',
        loadComponent: () => import('../../features/relationship/components/relationship/relationship.component').then(m => m.RelationshipComponent),
    },
    {
        path: 'category-list',
        loadComponent: () => import('../../features/category/components/category/category.component').then(m => m.CategoryComponent),
    },
    {
        path: 'feeds',
        loadComponent: () => import('../../features/posts/components/posts/posts.component').then(m => m.PostsComponent),
    },
     {
        path: 'prayer',
        loadComponent: () => import('../../features/prayer/components/prayer/prayer.component').then(m => m.PrayerComponent),
    },
    {
        path: 'add-verse-tag',
        loadComponent: () => import('../../features/bible/components/verse-tag-add/verse-tag-add.component').then(m => m.VerseTagAddComponent),
    },
    {
        path: 'page-add',
        loadComponent: () => import('../../features/page/components/add/add.component').then(m => m.AddComponent),
    },
    {
        path: 'page-edit/:id',
        loadComponent: () => import('../../features/page/components/add/add.component').then(m => m.AddComponent),
    },
    {
        path: 'page-list',
        loadComponent: () => import('../../features/page/components/list/list.component').then(m => m.ListComponent),
    },
    {
        path: 'blog-add',
        loadComponent: () => import('../../features/blog/components/blog-add/blog-add.component').then(m => m.BlogAddComponent),
    },
    {
        path: 'blog-edit/:id',
        loadComponent: () => import('../../features/blog/components/blog-add/blog-add.component').then(m => m.BlogAddComponent),
    },
    {
        path: 'blog-list',
        loadComponent: () => import('../../features/blog/components/blog/blog.component').then(m => m.BlogComponent),
    },
    {
        path: 'app-version-add',
        loadComponent: () => import('../../features/version/components/add/add.component').then(m => m.AddComponent),
    },
    {
        path: 'app-version-edit/:id',
        loadComponent: () => import('../../features/version/components/add/add.component').then(m => m.AddComponent),
    },
    {
        path: 'app-version-list',
        loadComponent: () => import('../../features/version/components/list/list.component').then(m => m.ListComponent),
    },
    {
        path: 'templates-add',
        loadComponent: () => import('../../features/templates/components/add/add.component').then(m => m.AddComponent),
    },
    {
        path: 'templates-edit/:id',
        loadComponent: () => import('../../features/templates/components/add/add.component').then(m => m.AddComponent),
    },
    {
        path: 'templates-list',
        loadComponent: () => import('../../features/templates/components/list/list.component').then(m => m.ListComponent),
    },
    {
        path: 'name-list',
        loadComponent: () => import('../../features/uniquename/components/list/list.component').then(m => m.ListComponent),
    },
     {
        path: 'keypersonroles-list',
        loadComponent: () => import('../../features/keypersonrole/components/keypersonrole/keypersonrole.component').then(m => m.KeyPersonRoleComponent),
    },
    {
        path: 'saints-list',
        loadComponent: () => import('../../features/saints/components/list/list.component').then(m => m.ListComponent),
    },
    {
        path: 'saints-add',
        loadComponent: () => import('../../features/saints/components/add/add.component').then(m => m.AddComponent),
    },
    {
        path: 'saints-edit/:id',
        loadComponent: () => import('../../features/saints/components/add/add.component').then(m => m.AddComponent),
    },
    {
        path: 'quotes-list',
        loadComponent: () => import('../../features/quotes/components/list/list.component').then(m => m.ListComponent),
    },
    {
        path: 'quotes-add',
        loadComponent: () => import('../../features/quotes/components/add/add.component').then(m => m.AddComponent),
    },
    {
        path: 'quotes-edit/:id',
        loadComponent: () => import('../../features/quotes/components/add/add.component').then(m => m.AddComponent),
    },
    {
        path: 'bible-feed-list',
        loadComponent: () => import('../../features/bible_feeds/components/list/list.component').then(m => m.ListComponent),
    },
    {
        path: 'bible-feed-add',
        loadComponent: () => import('../../features/bible_feeds/components/add/add.component').then(m => m.AddComponent),
    },
    {
        path: 'bible-feed-edit/:id',
        loadComponent: () => import('../../features/bible_feeds/components/add/add.component').then(m => m.AddComponent),
    },
    {
        path: 'enquiry-list',
        loadComponent: () => import('../../features/enquiry/components/list/list.component').then(m => m.ListComponent),
    },
    {
        path: 'enquiry-view/:id',
        loadComponent: () => import('../../features/enquiry/components/add/add.component').then(m => m.AddComponent),
    },
    {
        path: 'enquiry-subject-list',
        loadComponent: () => import('../../features/enquiry_subject/components/list/list.component').then(m => m.ListComponent),
    },
    {
        path: 'guidelines-list',
        loadComponent: () => import('../../features/guidelines/components/list/list.component').then(m => m.ListComponent),
    },
    {
        path: 'guidelines-add',
        loadComponent: () => import('../../features/guidelines/components/add/add.component').then(m => m.AddComponent),
    },
    {
        path: 'guidelines-edit/:id',
        loadComponent: () => import('../../features/guidelines/components/add/add.component').then(m => m.AddComponent),
    },
    {
        path: 'config-list',
        loadComponent: () => import('../../features/config/components/list/list.component').then(m => m.ListComponent),
    },
    // {
    //     path: 'config-edit/:id',
    //     loadComponent: () => import('../../features/config/components/add/add.component').then(m => m.AddComponent),
    // },
    {
        path: '**',
        redirectTo: 'dashboard',
        pathMatch: 'full'
    }
    
];